<mat-accordion multi>
    <mat-expansion-panel [expanded]="itemopen" class="mt-3 p-0">
        <mat-expansion-panel-header style="height: 0px;"></mat-expansion-panel-header>
        <span class="primary-color textTitle"> {{ 'DEVICE_HISTORY.LABEL1' | translate }} </span>

        <hr />

        <div class="row my-3">
            <div class="col-4 col-sm-4 col-md-3 ">
                <span class="normalBoldText black-color muted-color"> {{ 'DEVICE_HISTORY.LABEL2' | translate }} </span>
            </div>

            <div class="col-4 col-sm-4 col-md-3">
                <span class="normalBoldText black-color muted-color"> {{ 'DEVICE_HISTORY.LABEL3' | translate }} </span>
            </div>

            <div class="col-4 col-sm-4 col-md-3 fw-bold">
                <span class="normalBoldText black-color muted-color"> {{ 'DEVICE_HISTORY.LABEL4' | translate }} </span>
            </div>

            <div class="col-12 col-sm-12 col-md-3 fw-bold">
                <span class="d-none d-sm-none d-md-inline normalBoldText black-color muted-color"> {{ 'DEVICE_HISTORY.LABEL5' | translate }} </span>
            </div>
        </div>

        <div class="row" *ngFor="let row of claimHistory ; let i = index">
            <div class="col-4 col-sm-4 col-md-3 my-2">
                <span class="normalBoldText black-color muted-color">{{i + 1}}</span>
            </div>

            <div class="col-4 col-sm-4 col-md-3 my-2">
                <span class="normalBoldText black-color muted-color"><a
                        class="normalBoldText black-color text-decoration-none"
                        routerLink="tracking/{{device.SRNumber}}/{{row.ClaimNumber}}">{{ row.ClaimNumber }}</a></span>
            </div>

            <div class="col-4 col-sm-4 col-md-3 my-2">
                <span class="normalBoldText black-color muted-color">{{ row.ClaimEquipment.ClaimedEquipment.CreatedDate
                    | date: 'dd/MM/yyyy'}} </span>
            </div>

            <div class="col-12 col-sm-12 col-md-3 my-2">
                <span class="d-block d-sm-block d-md-none mt-3 normalText text-muted"> {{ 'DEVICE_HISTORY.LABEL5' | translate }} </span>
                <span data-bs-toggle="tooltip" data-bs-placement="top" title={{row.CustomerDescription}}
                    class="d-inline-block text-truncate normalText text-muted" style="max-width: 95%">
                    {{row.CustomerDescription}}</span>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>